var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34,11,9.16,4.68a1,1,0,1,1,1.41,1.53l-4.9,4.52H21a1,1,0,1,1,0,2.08H5.6l5,5a1,1,0,0,1-.73,1.77,1,1,0,0,1-.74-.3L2.31,12.47A1,1,0,0,1,2,11.71,1.05,1.05,0,0,1,2.34,11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e7fe704970384f3ebbe1f8e9d3124c37.svg";
export { ForwardRef as ReactComponent };